import { Component, OnInit, Inject, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { RteDialogRef, RTEAlertService } from 'rte-library';
import { MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { Report } from 'src/app/reports/components/report/models/report.model';
import { UserService } from 'src/app/service/services';
import { User } from 'src/app/models/user';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { debounceTime, switchMap, finalize, tap, distinctUntilChanged } from 'rxjs/operators';
import { UserPermissionReportService } from 'src/app/service/userPermissionReportService';
import { UserPermissionReport } from 'src/app/models/userPermissionReport';
import { Subscription, Subject } from 'rxjs';

@Component({
  selector: 'app-base-share-dialog',
  templateUrl: './base-share-dialog.component.html',
  styleUrls: ['./base-share-dialog.component.scss']
})
export class BaseShareDialogComponent implements OnInit, OnDestroy {

  displayedColumns = ['codigo', 'nome', 'login', 'email', 'acoes'];
  dataUsers: User[];
  dataSource: MatTableDataSource<UserPermissionReport> = new MatTableDataSource<UserPermissionReport>();
  errorMsg: string;
  filteredUsers: User[];
  isLoading = false;
  userName: string;
  userNameChanged: Subject<string> = new Subject<string>();
  selectedUser: UserPermissionReport = new UserPermissionReport();
  subscriptions: Subscription[];

  @ViewChild('inputName') inputName: ElementRef;

  constructor(public dialogRef: RteDialogRef<BaseShareDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Report,
    private userService: UserService,
    private userPermissionReportService: UserPermissionReportService,
    public alert: RTEAlertService,
    private fb: FormBuilder) {

      this.subscriptions = new Array<Subscription>();

      this.subscriptions.push(
        this.userPermissionReportService.saveSuccess$.subscribe(success => {
          this.getUsersWithPermissions();
          this.cleanUser();
          this.setFocus();
          this.cleanUsersFiltered();
          this.alert.success('Permissão salva com sucesso');
        })
      );

      this.subscriptions.push(
        this.userPermissionReportService.saveError$.subscribe(error => {
          this.alert.error('Erro ao salvar usuário');
        })
      );

      this.subscriptions.push(
        this.userPermissionReportService.deleteSuccess$.subscribe(success => {
          this.getUsersWithPermissions();
          this.setFocus();
          this.cleanUsersFiltered();
          this.alert.success('Permissão removida para este usuário');
        })
      );

      this.subscriptions.push(
        this.userPermissionReportService.deleteError$.subscribe(error => {
          this.alert.error('Erro ao remover permissão para este usuário');
        })
      );

      this.userNameChanged.pipe(debounceTime(500), distinctUntilChanged()).subscribe(model => {
        this.getUsers();
      });
    }

  ngOnInit() {
    this.getUsers();
    this.getUsersWithPermissions();
    this.setFocus();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(x => x.unsubscribe());
  }

  setFocus() {
    setTimeout(() => this.inputName.nativeElement.focus());
  }

  deleteUser(element: UserPermissionReport, sharedId: number) {
    element.ObjectId = sharedId;
    this.userPermissionReportService.delete(element);
  }

  cleanUser() {
    this.selectedUser = new UserPermissionReport();
    this.userName = '';
  }

  setUserSelected(user: User) {
    this.selectedUser.UserId = user.Id;
    this.selectedUser.Report = this.data;
    this.selectedUser.ObjectId = this.data.ObjectId;
  }

  keyPress(event: any) {
    if (event.key === 'Enter') {
      if (this.dataSource.data.find(x => x.UserId === Number(this.selectedUser.UserId))) {
        this.alert.info('Usuário já possui permissão para este relatório');
        this.cleanUser();
      } else {
        this.saveUserPermission();
      }
    }
  }

  saveUserPermission() {
    this.userPermissionReportService.save(this.selectedUser);
  }

  getUsersWithPermissions() {
    this.userPermissionReportService.getUserPermissionByReport(this.data).subscribe(result => {
      this.dataSource.data = result;
    });
  }

  onModelChange(event) {
    if (this.userName && this.userName !== '') {
      this.userNameChanged.next(event);
    } else {
      this.cleanUsersFiltered();
    }
  }

  cleanUsersFiltered() {
    this.filteredUsers = null;
  }

  getUsers() {
    if (this.userName) {
      if (this.userName.length > 0) {
        this.isLoading = true;
        this.userService.getUserByDescription(this.userName)
          .pipe(finalize(() => {
            this.isLoading = false;
          }),
        )
        .subscribe(data => {
          if (!data) {
            this.errorMsg = 'Erro na busca dos usuários.';
            this.filteredUsers = [];
          } else {
            this.errorMsg = '';
            this.filteredUsers = data;
          }
        });
      }
    }
  }
}
